<template>
  <div class="min-h-screen bg-slate-50">
    <!-- Sidebar -->
    <Sidebar />
    
    <!-- Main content with margin for fixed sidebar -->
    <div class="transition-all duration-300 min-h-screen bg-slate-50" style="margin-left: var(--sidebar-width, 320px)">
      <!-- Page content -->
      <main class="p-8">
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'

export default {
  name: 'NurseLayout',
  components: {
    Sidebar
  }
}
</script>

<style scoped>
/* Responsive adjustments */
@media (max-width: 768px) {
  /* Hide sidebar on mobile or adjust as needed */
}
</style> 